export class myFavorites {
	constructor( ) {       
		this.content = document.getElementById( 'savedContentItems' );
		
		if( !this.content ) {
			return;
		}

		this.pagination = document.getElementById( 'savedPagination' );
		this.paginationNum = this.pagination.querySelector('.pagination__numbers');
		this.noSaved = document.getElementById( 'noSavedContent' );
		this.pageLinks = document.querySelector( '.pagination__links' );
		this.first = document.querySelector('[data-page="first"]');
		this.prev = document.querySelector('[data-page="prev"]');
		this.next = document.querySelector('[data-page="next"]');
		this.last = document.querySelector('[data-page="last"]');

		this.rawStorage = localStorage.getItem('myFavorites')
		this.myFavorites = this.rawStorage ? JSON.parse(this.rawStorage) : { favorites:[] };
		this.favorites = this.myFavorites.favorites;

		this.favoriteCount = 9;
		this.currentPage = 1;
		this.totalPages = Math.ceil( this.favorites.length / this.favoriteCount );
		
		this.displaySetup();

		document.body.addEventListener('click', (e)=> {
            const node = e.target;
            if( node.classList.contains('favorite-toggle')) {
				this.removeFavorite(e.target.closest('.card'));
            }
			if( node.classList.contains('pagination__link')) {
                this.changePages(node);
            }
        });
	}

	/**
	 * Manages the display of the favorites section and pagination.
	 * - Hides the "no saved favorites" message if there are favorites, otherwise displays it.
	 * - Displays pagination if the number of favorites exceeds the allowed count.
	 */
	displaySetup() {
		// Check if the noSaved and pagination elements exist before proceeding
		if (!this.noSaved || !this.pagination) {
			console.error("Missing required DOM elements.");
			return;
		}

		// If there are no favorites, show the 'no saved favorites' message and exit
		if (!this.favorites.length) {
			this.noSaved.style.display = 'block';
			this.pagination.style.display = 'none'; // Ensure pagination is hidden if no favorites
			return;
		}

		// Hide the 'no saved favorites' message and display favorites
		this.noSaved.style.display = 'none';
		this.displayFavorites(this.currentPage);

		// Show or hide pagination based on the number of favorites
		if (this.favorites.length > this.favoriteCount) {
			this.pagination.style.display = 'block';

		} else {
			this.pagination.style.display = 'none';
		}
	}

	/**
	 * Removes a favorite card from the DOM and updates the favorites list in localStorage.
	 * After removal, recalculates pagination and updates the display accordingly.
	 * A delay is introduced using setTimeout for smoother UI updates.
	 *
	 * @param {HTMLElement} card - The DOM element representing the favorite to remove.
	 */
	removeFavorite(card) {
		// Remove the card from the DOM
		card?.remove();
		
		// Update the favorites and pagination after a delay
		setTimeout( ()=> {
			this.myFavorites = JSON.parse(localStorage.getItem('myFavorites'));
			this.favorites = this.myFavorites.favorites;
			this.totalPages = Math.ceil( this.favorites.length / this.favoriteCount );
			
			// Adjust currentPage if it's out of bounds
			if(this.currentPage > this.totalPages){
				this.currentPage = this.totalPages;
			}

			// Update the display based on the new state
			this.displaySetup();
		}, 100);
		
	}

	/**
	 * Retrieves a subset of favorite items based on the current page number.
	 * Calculates the start and end indices for slicing the favorites array.
	 *
	 * @param {number} [page] - The page number for pagination
	 * @returns {Array} A subset of the favorites array corresponding to the given page.
	 */
	getPaginatedItems(page) {
		// Calculate start and end indices for slicing
		const startIndex = (page - 1) * this.favoriteCount;
  		const endIndex = startIndex + this.favoriteCount;
		
		// Return the paginated subset of favorites
		return this.favorites.slice(startIndex, endIndex);
	}

	/**
	 * Changes the current page based on the button clicked.
	 * Handles both numeric page values and named actions like 'first', 'prev', 'next', and 'last'.
	 *
	 * @param {HTMLElement} button - The button element triggering the page change, containing a `data-page` attribute.
	 */
	changePages(button) {
		const { page: dataPage } = button.dataset;
		let page = parseInt(dataPage, 10);

		// Check if dataPage is a valid number, otherwise handle it as a named action
		if (isNaN(page)) {
			switch(dataPage) {
				case 'first':
					page = 1;
					break;
				case 'prev':
					page = Math.max(1, this.currentPage - 1); // Ensure page doesn't go below 1
					break;
				case 'next':
					page = Math.min(this.totalPages, this.currentPage + 1); // Ensure page doesn't exceed totalPages
					break;
				case 'last':
					page = this.totalPages;
					break;
				default:
					console.warn('Invalid data-page value.');
					return; // Early return if the action is not recognized
			}
		} 

		// Update the current page and refresh the displayed favorites
		this.currentPage = page;
		this.displayFavorites(page);
	}

	/**
	 * Generates an array of pagination elements based on the current page and total pages.
	 * Handles dynamic calculation of visible page numbers and ensures proper display of the current page.
	 *
	 * @returns {Array<string>} An array of HTML strings representing pagination elements.
	 */
	pageNumbers() {
		const pagesToShow = 5;
		let pageElements = [];
		// let startPage = this.currentPage - 2;
		// let endPage = this.currentPage + 2;
		
		// if(this.totalPages < pagesToShow || endPage > this.totalPages) {
		// 	endPage = this.totalPages;
		// 	startPage = this.totalPages - pagesToShow + 1;
		// } else if( endPage < pagesToShow) {
		// 	endPage = pagesToShow;
		// }
		// if(startPage < 1) {
		// 	startPage = 1;
		// } 

		 // Calculate start and end pages for the pagination display
		 let startPage = Math.max(1, this.currentPage - Math.floor(pagesToShow / 2));
		 let endPage = startPage + pagesToShow - 1;
	   
		 // Adjust startPage and endPage if necessary
		 if (endPage > this.totalPages) {
		   endPage = this.totalPages;
		   startPage = Math.max(1, endPage - pagesToShow + 1);
		 }
		
		// Generate HTML elements for each page number
		for( let i = startPage; i<= endPage ; i++) {
			if(this.currentPage === i) {
				pageElements.push(`
					<li class="pagination__number">
						<span class="pagination__link current aria-current="page">
							<span>${i}</span>
						</span>
					</li>
				`);
			} else {
				pageElements.push(`
					<li class="pagination__number">
						<button data-page="${i}" type="button" class="pagination__link">
							${i}
						</button>
					</li>
				`);
			}
			
		}

		
        return pageElements;
    }

	
	pageNumberDisplay() {
		const pages = this.pageNumbers();
		this.paginationNum.innerHTML = '';
		pages.forEach( (page)=> {
			this.paginationNum.insertAdjacentHTML('beforeend', page);
		});
	}

	/**
	 * Updates the pagination buttons' state based on the current page.
	 * Enables all buttons by default, then disables the appropriate buttons 
	 * depending on whether the current page is the first or last.
	 *
	 * @param {number} page - The current page number.
	 */
	updatePagination(page) {
		// Enable all pagination buttons
		const buttons = [
			this.first,
			this.prev,
			this.next,
			this.last
		];
		buttons.forEach(button => button.removeAttribute('disabled'));
		
		// Disable 'first' and 'prev' if on the first page
		if (page === 1) {
			this.first.setAttribute('disabled', 'disabled');
			this.prev.setAttribute('disabled', 'disabled');
		} 
		// Disable 'next' and 'last' if on the last page
		else if (page === this.totalPages) {
			this.next.setAttribute('disabled', 'disabled');
			this.last.setAttribute('disabled', 'disabled');
		} 
	}

	getImage(image) {
		if(!image) {
			return '';
		}
		return (
			`<figure class="card__media">
				<img src=${image} />
			</figure>`
		);
	}

	getPostType(post_type) {
		return (
			`<div class="card__kicker has-kicker-variant">${ post_type === 'mec-events' ? 'events' : post_type }</div>`
		);
	}

	getTitle(title, url) {
		if(title && url) {
			return (
				`<h3 class="card__heading">
					<a class="card__link" href="${ url }">
						${ title }
					</a>
				</h3>`
			);
		}else if(title) {
			return (
				`<h3 class="card__heading">${ title }</h3>`
			);
		}
	}

	getButton(title, post_id, post_type) {
		return (
            `<button type="button" class="favorite-toggle" data-post-id="${ post_id }" data-post-type="${ post_type }" data-is-favorited="true">
				<div class="favorite-toggle__icon">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 22"><path stroke="currentColor" d="M15.47 20.706v-20H.83v20l7.444-6.948 7.196 6.948Z"/></svg>
				</div>
				<span class="visually-hidden favorite-toggle__state-text">${ title }</span>
			</button>`
        );
	}

	getDate(date) {
		if(!date) {
			return '';
		}
		return (
			`<div class="card__byline">
				<span>${ date }</span>
			</div>`
		);
	}


	displayFavorites(page) {
		const favorites = this.getPaginatedItems(page);
		if(!favorites) return;
		
		this.pageNumberDisplay();
		this.updatePagination(page);
		this.content.innerHTML = '';
		favorites.forEach( (favorite) => {
			const template = 
				`<div class="card">
					<div class="card__wrap">
						${this.getImage(favorite.image)}
						<div className="card__text">
							${this.getPostType(favorite.post_type)}	
							${this.getTitle(favorite.title, favorite.url)}
							<div class="card__footer">
								${this.getButton(favorite.title,favorite.post_id, favorite.post_type)}
								${this.getDate(favorite.date)}
							</div>
						</div>
					</div>
				</div>`

			
			this.content.insertAdjacentHTML('beforeend', template);
		});
	}
	
}

document.addEventListener( 'DOMContentLoaded', () => {
	new myFavorites( ); 
} );
